import React from "react";
import BlogSlat from "../molecules/BlogSlat";
import { Helmet } from "react-helmet";

export default ({ data }) => {
  let posts = [];
  data.allMarkdownRemark.edges.forEach(({ node }) => {
    posts.push({
      excerpt: node.excerpt,
      title: node.frontmatter.title,
      date: node.frontmatter.date,
      uri: node.fields.slug,
      author: node.frontmatter.author
    });
  });
  data.allPostsJson.edges.forEach(({ node }) => {
    posts.push({
      excerpt: node.excerpt,
      title: node.title,
      date: node.date,
      uri: node.page + "/",
      author: node.author
    });
  });
  posts.sort((a, b) => (a.date < b.date ? 1 : -1));
  return (
    <div>
      <Helmet>
        <title>Limenius. Blog about development.</title>
      </Helmet>
      <div className="template">
        <div className="o-title--lettering o-lettering--container">
          <div className="container">
            <div className="o-lettering o-lettering__ultra">
              Something to tell
            </div>
          </div>
        </div>
        <div className="content container-sm">
          <div className="c-blog--index">
            <div className="u-guttered">
              {posts.map((entry, idx) => (
                <div key={idx}>
                  <BlogSlat entry={entry} />
                  <hr />
                </div>
              ))}
            </div>
            {/*remain.map((pair, idx) => (
                            <div key={idx} className="u-row">
                                {pair.map((entry, idx2) => (
                                    <div key={idx2} className="u-col u-col-6">
                                        <BlogSlatMinor entry={entry}/>
                                    </div>
                                ))}
                            </div>
                        ))*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export const query = graphql`
  query MyFilesQuery {
    allPostsJson {
      edges {
        node {
          excerpt
          date
          page
          title
          author
        }
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      totalCount
      edges {
        node {
          frontmatter {
            title
            author
            date
          }
          fields {
            slug
          }
          excerpt
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/blog.js